import isEmptyObject from './is-empty-object';

/**
 * Get specific country code from list of supported locales
 * @param {string} countryIsoCode
 * @param {array} supportedLocales
 * @returns {string} countryCode XX format like UK, US or null if no match
 */
const getCountryCodeByISO = (countryIsoCode, supportedLocales) => {
  if (countryIsoCode) {
    let selectedLocale = null;
    if (supportedLocales && Array.isArray(supportedLocales)) {
      selectedLocale = supportedLocales.find(locale => locale.iso_code === countryIsoCode);
    }
    if (!isEmptyObject(selectedLocale)) {
      return selectedLocale.code;
    }
  }
  return null;
};

export default getCountryCodeByISO;
